import { I18n } from '@calendly/i18n'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

export const useAdvancedSortable = (options) => {
  const sortable = useSortable(options)

  const itemStyle = {
    style: {
      transform: CSS.Translate.toString(sortable.transform),
      transition: sortable.transition,
    }
  }

  return {
    sortable: {
      ...sortable,
      attributes: {
        ...sortable.attributes,
        'aria-roledescription': undefined,
        'aria-label': I18n.t('publisher.components.sortable.handle')
      }
    },
    itemStyle
  }
}
